import React from 'react';
import { PencilIcon, TrashIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const HighDemandProductCard = ({ product, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 border border-slate-100">
            {/* Header with gradient */}
            <div className="bg-gradient-to-br from-primary-100 to-blue-50 p-6">
                <div className="flex items-center justify-between mb-3">
                    {/* Active Badge */}
                    <span className={`px-3 py-1.5 rounded-lg text-xs font-semibold ${product.is_active
                        ? 'bg-green-100 text-green-600'
                        : 'bg-slate-100 text-slate-500'
                        }`}>
                        {product.is_active ? 'Active' : 'Inactive'}
                    </span>

                    {/* Display Order Badge */}
                    <div className="bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1.5 shadow-sm">
                        <span className="text-sm font-bold text-gray-700">
                            #{product.display_order || 0}
                        </span>
                    </div>
                </div>

                {/* Icon */}
                <div className="flex items-center justify-center mb-2">
                    <CheckCircleIcon className="h-12 w-12 text-primary-600" />
                </div>
            </div>

            {/* Content */}
            <div className="p-5">
                {/* Product Name */}
                <h3 className="text-base font-bold text-slate-800 mb-4 text-center min-h-[48px] flex items-center justify-center">
                    {product.product_name}
                </h3>

                {/* Action Buttons */}
                <div className="flex gap-2 pt-4 border-t border-slate-100">
                    <button
                        onClick={() => onEdit(product)}
                        className="flex-1 flex items-center justify-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <PencilIcon className="h-4 w-4" />
                        Edit
                    </button>
                    <button
                        onClick={() => onDelete(product.id)}
                        className="flex-1 flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <TrashIcon className="h-4 w-4" />
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HighDemandProductCard;
